<template>
  <!-- 班级数据 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
      <!--  -->
      <div class="search">
        <div class="search-gropu">
          课程名称：
          <el-select v-model="course_name" @change="selectChange" placeholder="请选择课程">
            <el-option
              v-for="item in bigcourse"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu">
          课程期次：
          <el-select v-model="course" @visible-change="visibleSelectChange" placeholder="请选择课程期次">
            <el-option
              v-for="item in period_list"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu on">
          购买时间：
          <el-date-picker
            class="buy-time"
            v-model="buy_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
      </div>
      <div  class="search">
        <!--  -->
        <div class="search-gropu">
          <el-button style="margin-left:auto;" type="primary" @click="getTaList('del')" size="medium" >查询</el-button>
          <el-button style="margin-left:10px;" type="primary" @click="exportExcelHandle" size="medium">导出订单</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <!-- 总数 -->
        <div class="total">
          <div class="total-node">
            <!-- <h2>续报数据</h2> -->
            <div class="total-main">
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>续报数据</h4>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>学员总数</h4>
                  <h3>{{statObj.user_count||statObj.user_count==0?statObj.user_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>减掉联报学员总数</h4>
                  <h3>{{statObj.user_nojoint_count||statObj.user_nojoint_count==0?statObj.user_nojoint_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>学员续报人数</h4>
                  <h3>{{statObj.user_reorder_count||statObj.user_reorder_count==0?statObj.user_reorder_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>学员续报比例</h4>
                  <h3>{{statObj.user_reorder_rate||statObj.user_reorder_rate==0?statObj.user_reorder_rate:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>助教总数含教练</h4>
                  <h3>{{statObj.tutor_count||statObj.tutor_count==0?statObj.tutor_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>续报空间助教总数</h4>
                  <h3>{{statObj.tutor_reorderable_count||statObj.tutor_reorderable_count==0?statObj.tutor_reorderable_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>助教续报人数含教练</h4>
                  <h3>{{statObj.tutor_reorder_count||statObj.tutor_reorder_count==0?statObj.tutor_reorder_count:'--'}}</h3>
                </div>
              </div>
            </div>
          </div>
          <!-- 转介数据 -->
          <div class="total-node on">
            <!-- <h2>转介数据</h2> -->
            <div class="total-main">
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>转介数据</h4>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>学员发起转介人数</h4>
                  <h3>{{statObj.user_share_count || statObj.user_share_count==0?statObj.user_share_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>学员转介成功人数</h4>
                  <h3>{{statObj.user_referral_count || statObj.user_referral_count==0?statObj.user_referral_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>助教发起转介人数</h4>
                  <h3>{{statObj.tutor_share_count || statObj.tutor_share_count==0?statObj.tutor_share_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta">
                <div class="ta-child">
                  <h4>助教转介成功人数</h4>
                  <h3>{{statObj.tutor_referral_count || statObj.tutor_referral_count==0?statObj.tutor_referral_count:'--'}}</h3>
                </div>
              </div>
              <!--  -->
              <div class="ta"></div>
              <!--  -->
              <div class="ta"></div>
              <!--  -->
              <div class="ta"></div>
            </div>
          </div>
        </div>
        <!-- list -->
        <el-table :data="list" show-overflow-tooltip border style="width: 100%;margin-top:25px;" @filter-change="filterChange" >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="60" label="序号"></el-table-column>
          <el-table-column prop="nickname" label="用户昵称" width="190"></el-table-column>
          <el-table-column width="100" label="用户头像">
            <template slot-scope="scope">
              <div class="userinfo">
                <img :src="scope.row.headimgurl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="续报"
            width="80"
            :filter-multiple = "false"
            :filters="courseFilters"
            :column-key="'filter_reorder'"
            filter-placement="bottom-end"
          >
            <template slot-scope="scope">
              {{scope.row.reorder_count>0?'是':'否'}}
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="用户类型"
            :filter-multiple = "false"
            :filters="userFilters"
            :column-key="'filter_type'"
            filter-placement="bottom-end"
          >
            <template slot-scope="scope">
              <el-tag type="primary" size="small" v-if="scope.row.status==0">学员</el-tag>
              <el-tag type="success" size="small" v-if="scope.row.status==1">助教</el-tag>
              <el-tag type="warning" size="small" v-if="scope.row.status==2">教练</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="reorder_count" label="续报数量"></el-table-column> -->
          <el-table-column  label="续报课程期次" width="220">
            <template slot-scope="scope">
              <el-tag v-for="(item,index) in strToArray(scope.row.reorder_course)" :key="index" type="primary" size="small" >{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column  label="课程原价" width="100">
            <template slot-scope="scope">
              <el-tag v-for="(item,index) in strToArray(scope.row.reorder_originalprice)" :key="index" type="primary" size="small" >{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column  label="续报价格" width="100">
            <template slot-scope="scope">
              <el-tag v-for="(item,index) in strToArray(scope.row.reorder_price)" :key="index" type="primary" size="small" >{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column  label="续报时间" width="190">
            <template slot-scope="scope">
              <el-tag v-for="(item,index) in strToArray(scope.row.reorder_pay_time)" :key="index" type="primary" size="small" >{{item}}</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="reorder_shareuser_uid" label="续报转接人UID"></el-table-column> -->
          <el-table-column prop="reorder_shareuser_nickname" label="转介人"></el-table-column>
          <el-table-column width="100" label="转介人佣金">
            <template slot-scope="scope">
              <el-tag v-for="(item,index) in strToArray(scope.row.reorder_shareuser_fee)" :key="index" type="primary" size="small" >{{item}}</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="续报转介人头像">
            <template slot-scope="scope">
              <div class="userinfo">
                <img :src="scope.row.reorder_shareuser_headimgurl" alt />
              </div>
            </template>
          </el-table-column> -->
          
          <el-table-column prop="share_count" label="分享人数"></el-table-column>
          <el-table-column  label="转介成功人数">
            <template slot-scope="scope">
              <div @click="detailsHandle(scope.$index, scope.row)" style="cursor: pointer;color:#409eff;text-decoration: underline;">
                {{scope.row.referral_count}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="referral_fee" label="转介总佣金"></el-table-column>

          <!-- <el-table-column width="88" label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="detailsHandle(scope.$index, scope.row)"
              >详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- 分页 -->
        <el-pagination class="pages" 
            :page-sizes="[25, 50, 75, 100]"
            @size-change="handleSizeChange" 
            @current-change="handleCurrentChange" 
            :page-size="pages.size" 
            :current-page="pages.page"
            background 
            layout="sizes,prev, pager, next" 
            :total="pages.count"> 
        </el-pagination>
      </div>
    </div>
    <!--  -->
    <el-dialog title="转介成功人数" width="80%" :visible.sync="successful_referral" :close-on-click-modal="false">
      <el-table :data="succList">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="100"></el-table-column>
        <el-table-column label="用户头像">
          <template slot-scope="scope">
            <div class="userinfo">
              <img :src="scope.row.headimgurl" alt />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="course" label="报名课程期次" width="190"></el-table-column>
        <el-table-column prop="original_price" label="课程原价"></el-table-column>
        <el-table-column prop="pay_price" label="付款价格"></el-table-column>
        <el-table-column prop="pay_time" label="付款时间"></el-table-column>
        <el-table-column prop="transfer_course" label="调期课程期次" width="190"></el-table-column>
        <el-table-column prop="transfer_time" label="调期时间"></el-table-column>
        <el-table-column prop="fee" label="佣金" ></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer" >
        <el-button @click="successful_referral = false">关  闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  reorderStatCount,
  reorderStatList,
  getCourseList,
  reorderStatAll,
  referralDetail
} from "@/api/operating";
import { exportExcel,deepCopy } from "@u/tools";
export default {
  data() {
    return {
      list: [],
      pages: {},
      bigcourse: [],
      courseList: [],
      period_list: [],
      course_name: "",
      course: null,
      buy_time: [],
      // 获取总数
      statObj: {},
      // 表格筛选
      userFilters: [
        {
          value: 1,
          text: "学员"
        },
        {
          value: 2,
          text: "助教"
        }
      ],
      courseFilters: [
        {
          value: 0,
          text: "否"
        },
        {
          value: 1,
          text: "是"
        }
      ],
      // 搜索条件
      obj:{},
      // 转介成功人数
      successful_referral:false,
      succList:[]
    }
  },
  methods: {
    // 转换为数组
    strToArray(s){
      let str = s?String(s):'';
      if(str && str.split(',') && str.split(',').length>0){
        return str.split(',')
      }else{
        return str?[str]:[]
      }
      
    },
    //导出的方法
    exportExcelHandle() {
      // • "":"用户类型，0=学员，1=助教，2=教练",
      let h = [
        '用户ID', '用户昵称','用户头像','课程期次','用户类型','续报数量','续报课程期次','续报课程原价','续报转接人UID',
        '续报转介人昵称','续报转介人头像','续报转介人佣金','分享人数','转介成功人数','转介总佣金'
      ];
      let b =  [
        'uid', 'nickname','headimgurl','course','status','reorder_count','reorder_course','reorder_originalprice','reorder_shareuser_uid',
        'reorder_shareuser_nickname', 'reorder_shareuser_headimgurl','reorder_shareuser_fee','share_count','referral_count','referral_fee'
      ];
      
      reorderStatAll(this.obj).then((res)=>{
        let list = res.list;  //把data里的tableData存到list
        for(let key in list){
          // 类型转换
          if(list[key].status ==0){
              list[key].status =  '学员';
          }
          if(list[key].status ==1){
              list[key].status =  '助教';
          }
          if(list[key].status ==2){
              list[key].status =  '教练';
          }
          
      }
      exportExcel(h,b,list,'课程转介续报');
    
      })
          
    },
    // 获取当前转介成功用户详情
    detailsHandle(index,row){
      this.$showLoading();
      referralDetail({
        uid:row.uid
      }).then((data)=>{
        if(data.error >0){
          this.$message(data.msg);
          return
        }

        this.succList = data.list;
        this.successful_referral= true;
        this.$hideLoading();
      }).catch(err => {
        this.$hideLoading();
      });
    },
    // 筛选
    filterChange(filters){
      let key = Object.keys(filters);
      // 获取筛选条件得第一个
      this.obj[key[0]] = filters[key[0]][0];
      this.getTaList();
    },
    // 点击期次触发
    visibleSelectChange(val) {
      if (!this.course_name) {
        this.$message("请先选择课程！");
        return;
      }
    },
    selectChange(val) {
      this.course = null;
      this.period_list = [];
      for (let i = 0; i < this.courseList.length; i++) {
        if (this.courseList[i].bigcourse == this.course_name) {
          this.period_list[this.period_list.length] = {
            id: this.courseList[i].cid,
            name: this.courseList[i].course
          };
        }
      }
      if (!this.course && !val) {
        this.course = this.period_list[0].id;
      }
    },
    // 调整每页显示条数
    handleSizeChange(val) {
        this.pages.size = val;
        this.getTaList();
    },
    // 触发分页
    handleCurrentChange(val) {
        this.pages.page = val;
        this.getTaList();
    },
    // 获取数据
    getTaList() {
      if (!this.course || !this.course_name) {
        this.$message("请先选择课程或期次！");
        return;
      }
      this.$showLoading();
      this.obj.page = Object.keys(this.pages).length>0?this.pages.page:1;
      this.obj.size = Object.keys(this.pages).length>0?this.pages.size:25;

      if (this.course) {
        this.obj["cid"] = this.course;
      }
      if (this.buy_time.length > 0) {
        this.obj["start_time"] = this.buy_time[0]; //开始时间
        this.obj["end_time"] = this.buy_time[1]; //结束时间
      }

      reorderStatList(this.obj).then(data => {
        if(data.error >0){
          this.$message(data.msg);
          return
        }
        this.$forceUpdate();
        this.list = data.list;
        this.$hideLoading();
      })
      .catch(err => {
        this.$hideLoading();
      });
      let obj = {};
      if (this.course) {
        obj["cid"] = this.course;
      }
      if (this.buy_time.length > 0) {
        obj["start_time"] = this.buy_time[0]; //开始时间
        obj["end_time"] = this.buy_time[1]; //结束时间
      }
      // 获取总数
      reorderStatCount(obj).then(data => {
        this.statObj = data;
      });
    },
    // 初始化获取数据
    pullData() {
      this.$showLoading();
      getCourseList()
        .then(data => {
          this.bigcourse = data.bigcourse;
          this.courseList = data.list;
          let idx = data.list.length - 1;
          if (idx >= 0 && !this.course_name) {
            this.course_name = this.bigcourse[0].name;
            this.selectChange();
            this.getTaList();
          }
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}
.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages {
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 30px;
}
.search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
  display: flex;
  align-items: center;
}
.search-gropu.on {
  flex: 1.5;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}
.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
.qrcode,
.qrcode img {
  width: 100%;
}

.line-bar {
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  .bar-tools {
    margin-left: auto;
    display: flex;
    align-items: center;
    a {
      display: block;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #ccc;
      color: #fff;
      cursor: pointer;
      &:nth-child(1) {
        margin-right: 10px;
      }
    }
    a.on {
      background-color: #409eff;
    }
  }
}

//
.total {
  display: flex;
  flex-direction: column;
  border-radius: 5px;

  .total-node {
    flex: 1;
    // border: 1px solid #dcdcdc;
    // padding: 15px;
    h2 {
      margin: 0;
      font-size: 18px;
    }
    h4 {
      font-weight: normal;
      margin: auto;
    }
    h3 {
      margin: auto;
    }
    .total-main {
      display: flex;
      font-size: 16px;
      .ta {
        display: flex;
        justify-content: center;
        width: 12.5%;
        flex: 1;
        border: 1px solid #dcdcdc;
        border-right: none;
        box-sizing: border-box;
        &:last-child{
          border-right: 1px solid #dcdcdc;
        }
        .ta-child {
          flex:1;
          text-align: center;
          display: flex;
          flex-direction: column;
          min-height: 80px;
        }
      }
    }
  }
  .total-node.on{
    .ta {
      border-top: none;
    }
  }
}
.el-tag--small{
  margin-bottom: 10px;
}
</style>
